"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFixed = void 0;
var precise_1 = require("./precise");
function toFixed(source, digits) {
    if (digits === void 0) { digits = 2; }
    var num = parseFloat("" + source);
    var times = Math.pow(10, digits);
    num = precise_1.precise(num * times + 0.5);
    num = parseInt("" + num, 10) / times;
    return precise_1.precise(num).toFixed(digits);
}
exports.toFixed = toFixed;
